import * as React from 'react';
export const FormsGlyph = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M34.0274 34.8328L48.6316 39.8643L29.6042 50.0001L15 44.9685L34.0274 34.8328Z", fill: "var(--color__glyph__primary)" }),
    React.createElement("rect", { x: 31.8154, y: 14, width: 17.805, height: 25.3886, transform: "rotate(35.2933 31.8154 14)", fill: "var(--color__glyph__accent)" })));
